import { TabContent, TabContentPropertiesForRent, TabContentPropertiesForSale } from '../types';

export const isPropertiesForSaleOrRentTab = (
  tabContent: NonNullable<TabContent>,
): tabContent is TabContentPropertiesForSale | TabContentPropertiesForRent =>
  tabContent.__typename === 'SchoolPage_PropertiesForSale' ||
  tabContent.__typename === 'SchoolPage_PropertiesForRent';
